/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root';
import { Route as UploadRouteImport } from './routes/upload';
import { Route as VerifyEmailRouteImport } from './routes/_verify-email';
import { Route as PublicRouteImport } from './routes/_public';
import { Route as AuthenticatedRouteImport } from './routes/_authenticated';
import { Route as AccountSetupRouteImport } from './routes/_account-setup';
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index';
import { Route as UploadSuccessRouteImport } from './routes/upload/success';
import { Route as UploadTokenRouteImport } from './routes/upload/$token';
import { Route as VerifyEmailVerifyEmailRouteImport } from './routes/_verify-email/verify-email';
import { Route as PublicResetPasswordRouteImport } from './routes/_public/reset-password';
import { Route as PublicRegisterRouteImport } from './routes/_public/register';
import { Route as PublicLoginRouteImport } from './routes/_public/login';
import { Route as PublicForgotPasswordRouteImport } from './routes/_public/forgot-password';
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings';
import { Route as AuthenticatedRiskAssessmentRouteImport } from './routes/_authenticated/risk-assessment';
import { Route as AuthenticatedDeletedAssessmentsRouteImport } from './routes/_authenticated/deleted-assessments';
import { Route as AccountSetupAccountSetupRouteImport } from './routes/_account-setup/account-setup';
import { Route as AuthenticatedRiskAssessmentIdRouteImport } from './routes/_authenticated/risk-assessment/$id';
import { Route as AuthenticatedRiskAssessmentIdReportRouteImport } from './routes/_authenticated/risk-assessment/$id/report';
import { Route as AuthenticatedRiskAssessmentIdListSelectionRouteImport } from './routes/_authenticated/risk-assessment/$id/list-selection';
import { Route as AuthenticatedRiskAssessmentIdDepthSelectionRouteImport } from './routes/_authenticated/risk-assessment/$id/depth-selection';
import { Route as AuthenticatedRiskAssessmentIdClientDetailsRouteImport } from './routes/_authenticated/risk-assessment/$id/client-details';

const UploadRoute = UploadRouteImport.update({
  id: '/upload',
  path: '/upload',
  getParentRoute: () => rootRouteImport,
} as any);
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/_verify-email',
  getParentRoute: () => rootRouteImport,
} as any);
const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any);
const AccountSetupRoute = AccountSetupRouteImport.update({
  id: '/_account-setup',
  getParentRoute: () => rootRouteImport,
} as any);
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const UploadSuccessRoute = UploadSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => UploadRoute,
} as any);
const UploadTokenRoute = UploadTokenRouteImport.update({
  id: '/$token',
  path: '/$token',
  getParentRoute: () => UploadRoute,
} as any);
const VerifyEmailVerifyEmailRoute = VerifyEmailVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => VerifyEmailRoute,
} as any);
const PublicResetPasswordRoute = PublicResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PublicRoute,
} as any);
const PublicRegisterRoute = PublicRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => PublicRoute,
} as any);
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any);
const PublicForgotPasswordRoute = PublicForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => PublicRoute,
} as any);
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any);
const AuthenticatedRiskAssessmentRoute =
  AuthenticatedRiskAssessmentRouteImport.update({
    id: '/risk-assessment',
    path: '/risk-assessment',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AuthenticatedDeletedAssessmentsRoute =
  AuthenticatedDeletedAssessmentsRouteImport.update({
    id: '/deleted-assessments',
    path: '/deleted-assessments',
    getParentRoute: () => AuthenticatedRoute,
  } as any);
const AccountSetupAccountSetupRoute =
  AccountSetupAccountSetupRouteImport.update({
    id: '/account-setup',
    path: '/account-setup',
    getParentRoute: () => AccountSetupRoute,
  } as any);
const AuthenticatedRiskAssessmentIdRoute =
  AuthenticatedRiskAssessmentIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedRiskAssessmentRoute,
  } as any);
const AuthenticatedRiskAssessmentIdReportRoute =
  AuthenticatedRiskAssessmentIdReportRouteImport.update({
    id: '/report',
    path: '/report',
    getParentRoute: () => AuthenticatedRiskAssessmentIdRoute,
  } as any);
const AuthenticatedRiskAssessmentIdListSelectionRoute =
  AuthenticatedRiskAssessmentIdListSelectionRouteImport.update({
    id: '/list-selection',
    path: '/list-selection',
    getParentRoute: () => AuthenticatedRiskAssessmentIdRoute,
  } as any);
const AuthenticatedRiskAssessmentIdDepthSelectionRoute =
  AuthenticatedRiskAssessmentIdDepthSelectionRouteImport.update({
    id: '/depth-selection',
    path: '/depth-selection',
    getParentRoute: () => AuthenticatedRiskAssessmentIdRoute,
  } as any);
const AuthenticatedRiskAssessmentIdClientDetailsRoute =
  AuthenticatedRiskAssessmentIdClientDetailsRouteImport.update({
    id: '/client-details',
    path: '/client-details',
    getParentRoute: () => AuthenticatedRiskAssessmentIdRoute,
  } as any);

export interface FileRoutesByFullPath {
  '/upload': typeof UploadRouteWithChildren;
  '/account-setup': typeof AccountSetupAccountSetupRoute;
  '/deleted-assessments': typeof AuthenticatedDeletedAssessmentsRoute;
  '/risk-assessment': typeof AuthenticatedRiskAssessmentRouteWithChildren;
  '/settings': typeof AuthenticatedSettingsRoute;
  '/forgot-password': typeof PublicForgotPasswordRoute;
  '/login': typeof PublicLoginRoute;
  '/register': typeof PublicRegisterRoute;
  '/reset-password': typeof PublicResetPasswordRoute;
  '/verify-email': typeof VerifyEmailVerifyEmailRoute;
  '/upload/$token': typeof UploadTokenRoute;
  '/upload/success': typeof UploadSuccessRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/risk-assessment/$id': typeof AuthenticatedRiskAssessmentIdRouteWithChildren;
  '/risk-assessment/$id/client-details': typeof AuthenticatedRiskAssessmentIdClientDetailsRoute;
  '/risk-assessment/$id/depth-selection': typeof AuthenticatedRiskAssessmentIdDepthSelectionRoute;
  '/risk-assessment/$id/list-selection': typeof AuthenticatedRiskAssessmentIdListSelectionRoute;
  '/risk-assessment/$id/report': typeof AuthenticatedRiskAssessmentIdReportRoute;
}
export interface FileRoutesByTo {
  '/upload': typeof UploadRouteWithChildren;
  '/account-setup': typeof AccountSetupAccountSetupRoute;
  '/deleted-assessments': typeof AuthenticatedDeletedAssessmentsRoute;
  '/risk-assessment': typeof AuthenticatedRiskAssessmentRouteWithChildren;
  '/settings': typeof AuthenticatedSettingsRoute;
  '/forgot-password': typeof PublicForgotPasswordRoute;
  '/login': typeof PublicLoginRoute;
  '/register': typeof PublicRegisterRoute;
  '/reset-password': typeof PublicResetPasswordRoute;
  '/verify-email': typeof VerifyEmailVerifyEmailRoute;
  '/upload/$token': typeof UploadTokenRoute;
  '/upload/success': typeof UploadSuccessRoute;
  '/': typeof AuthenticatedIndexRoute;
  '/risk-assessment/$id': typeof AuthenticatedRiskAssessmentIdRouteWithChildren;
  '/risk-assessment/$id/client-details': typeof AuthenticatedRiskAssessmentIdClientDetailsRoute;
  '/risk-assessment/$id/depth-selection': typeof AuthenticatedRiskAssessmentIdDepthSelectionRoute;
  '/risk-assessment/$id/list-selection': typeof AuthenticatedRiskAssessmentIdListSelectionRoute;
  '/risk-assessment/$id/report': typeof AuthenticatedRiskAssessmentIdReportRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/_account-setup': typeof AccountSetupRouteWithChildren;
  '/_authenticated': typeof AuthenticatedRouteWithChildren;
  '/_public': typeof PublicRouteWithChildren;
  '/_verify-email': typeof VerifyEmailRouteWithChildren;
  '/upload': typeof UploadRouteWithChildren;
  '/_account-setup/account-setup': typeof AccountSetupAccountSetupRoute;
  '/_authenticated/deleted-assessments': typeof AuthenticatedDeletedAssessmentsRoute;
  '/_authenticated/risk-assessment': typeof AuthenticatedRiskAssessmentRouteWithChildren;
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute;
  '/_public/forgot-password': typeof PublicForgotPasswordRoute;
  '/_public/login': typeof PublicLoginRoute;
  '/_public/register': typeof PublicRegisterRoute;
  '/_public/reset-password': typeof PublicResetPasswordRoute;
  '/_verify-email/verify-email': typeof VerifyEmailVerifyEmailRoute;
  '/upload/$token': typeof UploadTokenRoute;
  '/upload/success': typeof UploadSuccessRoute;
  '/_authenticated/': typeof AuthenticatedIndexRoute;
  '/_authenticated/risk-assessment/$id': typeof AuthenticatedRiskAssessmentIdRouteWithChildren;
  '/_authenticated/risk-assessment/$id/client-details': typeof AuthenticatedRiskAssessmentIdClientDetailsRoute;
  '/_authenticated/risk-assessment/$id/depth-selection': typeof AuthenticatedRiskAssessmentIdDepthSelectionRoute;
  '/_authenticated/risk-assessment/$id/list-selection': typeof AuthenticatedRiskAssessmentIdListSelectionRoute;
  '/_authenticated/risk-assessment/$id/report': typeof AuthenticatedRiskAssessmentIdReportRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/upload'
    | '/account-setup'
    | '/deleted-assessments'
    | '/risk-assessment'
    | '/settings'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/upload/$token'
    | '/upload/success'
    | '/'
    | '/risk-assessment/$id'
    | '/risk-assessment/$id/client-details'
    | '/risk-assessment/$id/depth-selection'
    | '/risk-assessment/$id/list-selection'
    | '/risk-assessment/$id/report';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/upload'
    | '/account-setup'
    | '/deleted-assessments'
    | '/risk-assessment'
    | '/settings'
    | '/forgot-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/upload/$token'
    | '/upload/success'
    | '/'
    | '/risk-assessment/$id'
    | '/risk-assessment/$id/client-details'
    | '/risk-assessment/$id/depth-selection'
    | '/risk-assessment/$id/list-selection'
    | '/risk-assessment/$id/report';
  id:
    | '__root__'
    | '/_account-setup'
    | '/_authenticated'
    | '/_public'
    | '/_verify-email'
    | '/upload'
    | '/_account-setup/account-setup'
    | '/_authenticated/deleted-assessments'
    | '/_authenticated/risk-assessment'
    | '/_authenticated/settings'
    | '/_public/forgot-password'
    | '/_public/login'
    | '/_public/register'
    | '/_public/reset-password'
    | '/_verify-email/verify-email'
    | '/upload/$token'
    | '/upload/success'
    | '/_authenticated/'
    | '/_authenticated/risk-assessment/$id'
    | '/_authenticated/risk-assessment/$id/client-details'
    | '/_authenticated/risk-assessment/$id/depth-selection'
    | '/_authenticated/risk-assessment/$id/list-selection'
    | '/_authenticated/risk-assessment/$id/report';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  AccountSetupRoute: typeof AccountSetupRouteWithChildren;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  PublicRoute: typeof PublicRouteWithChildren;
  VerifyEmailRoute: typeof VerifyEmailRouteWithChildren;
  UploadRoute: typeof UploadRouteWithChildren;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upload': {
      id: '/upload';
      path: '/upload';
      fullPath: '/upload';
      preLoaderRoute: typeof UploadRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_verify-email': {
      id: '/_verify-email';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof VerifyEmailRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_public': {
      id: '/_public';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof PublicRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated': {
      id: '/_authenticated';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthenticatedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_account-setup': {
      id: '/_account-setup';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AccountSetupRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/_authenticated/': {
      id: '/_authenticated/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthenticatedIndexRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/upload/success': {
      id: '/upload/success';
      path: '/success';
      fullPath: '/upload/success';
      preLoaderRoute: typeof UploadSuccessRouteImport;
      parentRoute: typeof UploadRoute;
    };
    '/upload/$token': {
      id: '/upload/$token';
      path: '/$token';
      fullPath: '/upload/$token';
      preLoaderRoute: typeof UploadTokenRouteImport;
      parentRoute: typeof UploadRoute;
    };
    '/_verify-email/verify-email': {
      id: '/_verify-email/verify-email';
      path: '/verify-email';
      fullPath: '/verify-email';
      preLoaderRoute: typeof VerifyEmailVerifyEmailRouteImport;
      parentRoute: typeof VerifyEmailRoute;
    };
    '/_public/reset-password': {
      id: '/_public/reset-password';
      path: '/reset-password';
      fullPath: '/reset-password';
      preLoaderRoute: typeof PublicResetPasswordRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_public/register': {
      id: '/_public/register';
      path: '/register';
      fullPath: '/register';
      preLoaderRoute: typeof PublicRegisterRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_public/login': {
      id: '/_public/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof PublicLoginRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_public/forgot-password': {
      id: '/_public/forgot-password';
      path: '/forgot-password';
      fullPath: '/forgot-password';
      preLoaderRoute: typeof PublicForgotPasswordRouteImport;
      parentRoute: typeof PublicRoute;
    };
    '/_authenticated/settings': {
      id: '/_authenticated/settings';
      path: '/settings';
      fullPath: '/settings';
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/risk-assessment': {
      id: '/_authenticated/risk-assessment';
      path: '/risk-assessment';
      fullPath: '/risk-assessment';
      preLoaderRoute: typeof AuthenticatedRiskAssessmentRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_authenticated/deleted-assessments': {
      id: '/_authenticated/deleted-assessments';
      path: '/deleted-assessments';
      fullPath: '/deleted-assessments';
      preLoaderRoute: typeof AuthenticatedDeletedAssessmentsRouteImport;
      parentRoute: typeof AuthenticatedRoute;
    };
    '/_account-setup/account-setup': {
      id: '/_account-setup/account-setup';
      path: '/account-setup';
      fullPath: '/account-setup';
      preLoaderRoute: typeof AccountSetupAccountSetupRouteImport;
      parentRoute: typeof AccountSetupRoute;
    };
    '/_authenticated/risk-assessment/$id': {
      id: '/_authenticated/risk-assessment/$id';
      path: '/$id';
      fullPath: '/risk-assessment/$id';
      preLoaderRoute: typeof AuthenticatedRiskAssessmentIdRouteImport;
      parentRoute: typeof AuthenticatedRiskAssessmentRoute;
    };
    '/_authenticated/risk-assessment/$id/report': {
      id: '/_authenticated/risk-assessment/$id/report';
      path: '/report';
      fullPath: '/risk-assessment/$id/report';
      preLoaderRoute: typeof AuthenticatedRiskAssessmentIdReportRouteImport;
      parentRoute: typeof AuthenticatedRiskAssessmentIdRoute;
    };
    '/_authenticated/risk-assessment/$id/list-selection': {
      id: '/_authenticated/risk-assessment/$id/list-selection';
      path: '/list-selection';
      fullPath: '/risk-assessment/$id/list-selection';
      preLoaderRoute: typeof AuthenticatedRiskAssessmentIdListSelectionRouteImport;
      parentRoute: typeof AuthenticatedRiskAssessmentIdRoute;
    };
    '/_authenticated/risk-assessment/$id/depth-selection': {
      id: '/_authenticated/risk-assessment/$id/depth-selection';
      path: '/depth-selection';
      fullPath: '/risk-assessment/$id/depth-selection';
      preLoaderRoute: typeof AuthenticatedRiskAssessmentIdDepthSelectionRouteImport;
      parentRoute: typeof AuthenticatedRiskAssessmentIdRoute;
    };
    '/_authenticated/risk-assessment/$id/client-details': {
      id: '/_authenticated/risk-assessment/$id/client-details';
      path: '/client-details';
      fullPath: '/risk-assessment/$id/client-details';
      preLoaderRoute: typeof AuthenticatedRiskAssessmentIdClientDetailsRouteImport;
      parentRoute: typeof AuthenticatedRiskAssessmentIdRoute;
    };
  }
}

interface AccountSetupRouteChildren {
  AccountSetupAccountSetupRoute: typeof AccountSetupAccountSetupRoute;
}

const AccountSetupRouteChildren: AccountSetupRouteChildren = {
  AccountSetupAccountSetupRoute: AccountSetupAccountSetupRoute,
};

const AccountSetupRouteWithChildren = AccountSetupRoute._addFileChildren(
  AccountSetupRouteChildren,
);

interface AuthenticatedRiskAssessmentIdRouteChildren {
  AuthenticatedRiskAssessmentIdClientDetailsRoute: typeof AuthenticatedRiskAssessmentIdClientDetailsRoute;
  AuthenticatedRiskAssessmentIdDepthSelectionRoute: typeof AuthenticatedRiskAssessmentIdDepthSelectionRoute;
  AuthenticatedRiskAssessmentIdListSelectionRoute: typeof AuthenticatedRiskAssessmentIdListSelectionRoute;
  AuthenticatedRiskAssessmentIdReportRoute: typeof AuthenticatedRiskAssessmentIdReportRoute;
}

const AuthenticatedRiskAssessmentIdRouteChildren: AuthenticatedRiskAssessmentIdRouteChildren =
  {
    AuthenticatedRiskAssessmentIdClientDetailsRoute:
      AuthenticatedRiskAssessmentIdClientDetailsRoute,
    AuthenticatedRiskAssessmentIdDepthSelectionRoute:
      AuthenticatedRiskAssessmentIdDepthSelectionRoute,
    AuthenticatedRiskAssessmentIdListSelectionRoute:
      AuthenticatedRiskAssessmentIdListSelectionRoute,
    AuthenticatedRiskAssessmentIdReportRoute:
      AuthenticatedRiskAssessmentIdReportRoute,
  };

const AuthenticatedRiskAssessmentIdRouteWithChildren =
  AuthenticatedRiskAssessmentIdRoute._addFileChildren(
    AuthenticatedRiskAssessmentIdRouteChildren,
  );

interface AuthenticatedRiskAssessmentRouteChildren {
  AuthenticatedRiskAssessmentIdRoute: typeof AuthenticatedRiskAssessmentIdRouteWithChildren;
}

const AuthenticatedRiskAssessmentRouteChildren: AuthenticatedRiskAssessmentRouteChildren =
  {
    AuthenticatedRiskAssessmentIdRoute:
      AuthenticatedRiskAssessmentIdRouteWithChildren,
  };

const AuthenticatedRiskAssessmentRouteWithChildren =
  AuthenticatedRiskAssessmentRoute._addFileChildren(
    AuthenticatedRiskAssessmentRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedDeletedAssessmentsRoute: typeof AuthenticatedDeletedAssessmentsRoute;
  AuthenticatedRiskAssessmentRoute: typeof AuthenticatedRiskAssessmentRouteWithChildren;
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute;
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedDeletedAssessmentsRoute: AuthenticatedDeletedAssessmentsRoute,
  AuthenticatedRiskAssessmentRoute:
    AuthenticatedRiskAssessmentRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

interface PublicRouteChildren {
  PublicForgotPasswordRoute: typeof PublicForgotPasswordRoute;
  PublicLoginRoute: typeof PublicLoginRoute;
  PublicRegisterRoute: typeof PublicRegisterRoute;
  PublicResetPasswordRoute: typeof PublicResetPasswordRoute;
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicForgotPasswordRoute: PublicForgotPasswordRoute,
  PublicLoginRoute: PublicLoginRoute,
  PublicRegisterRoute: PublicRegisterRoute,
  PublicResetPasswordRoute: PublicResetPasswordRoute,
};

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren);

interface VerifyEmailRouteChildren {
  VerifyEmailVerifyEmailRoute: typeof VerifyEmailVerifyEmailRoute;
}

const VerifyEmailRouteChildren: VerifyEmailRouteChildren = {
  VerifyEmailVerifyEmailRoute: VerifyEmailVerifyEmailRoute,
};

const VerifyEmailRouteWithChildren = VerifyEmailRoute._addFileChildren(
  VerifyEmailRouteChildren,
);

interface UploadRouteChildren {
  UploadTokenRoute: typeof UploadTokenRoute;
  UploadSuccessRoute: typeof UploadSuccessRoute;
}

const UploadRouteChildren: UploadRouteChildren = {
  UploadTokenRoute: UploadTokenRoute,
  UploadSuccessRoute: UploadSuccessRoute,
};

const UploadRouteWithChildren =
  UploadRoute._addFileChildren(UploadRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  AccountSetupRoute: AccountSetupRouteWithChildren,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
  VerifyEmailRoute: VerifyEmailRouteWithChildren,
  UploadRoute: UploadRouteWithChildren,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
